import React, { useState } from 'react';
import { FiUpload, FiTrash2, FiZoomIn } from 'react-icons/fi';

const UploadComponent = ({ files, onFileUpdate }) => {

  const handleFileChange = (event) => {
    const newFiles = Array.from(event.target.files).map((file) => ({ file, category: 'Balcony' }));
    onFileUpdate([...files, ...newFiles]);
  };

  const handleDragOver = (event) => {
    event.preventDefault();
  };

  const handleDrop = (event) => {
    event.preventDefault();
    const droppedFiles = Array.from(event.dataTransfer.files).map((file) => ({ file, category: 'Balcony' }));
    onFileUpdate([...files, ...droppedFiles]);
  };

  const handleRemoveFile = (index) => {
    onFileUpdate(files.filter((_, i) => i !== index));
  };

  const handleCategoryChange = (index, newCategory) => {
    const updatedFiles = [...files];
    updatedFiles[index].category = newCategory;
    onFileUpdate(updatedFiles);
  };

  return (
    <div className="flex flex-col items-center">
      <div
        className="flex flex-col items-center justify-center border-2 border-dashed border-blue-400 rounded-lg px-4 py-2 bg-blue-50 w-full max-w-md mx-auto mb-6"
        onDragOver={handleDragOver}
        onDrop={handleDrop}
        onClick={() => document.getElementById('fileInput').click()}
      >
        <div className="flex flex-col items-center mb-4">
          <div className="bg-blue-100 rounded-full p-3 mb-2">
            <FiUpload className="text-blue-500 text-4xl" />
          </div>
          <p className="text-blue-600 font-medium">+ Add at least 5 photos</p>
        </div>
        <p className="text-gray-600 text-sm mb-4 text-center">
          Drag and drop your photos here or click to upload
        </p>
        <p className="text-gray-500 text-xs mb-4 text-center">
          Up to 50 photos • Max size 10 MB • Formats: png, jpg, jpeg, gif, webp, heic, heif
        </p>
        <input
          type="file"
          multiple
          accept="image/png, image/jpeg, image/gif, image/webp, image/heic, image/heif"
          className="hidden"
          id="fileInput"
          onChange={handleFileChange}
        />
      </div>

      {files.length > 0 && (
        <div className="w-full grid  grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
          {files.map((item, index) => (
            <div key={index} className="relative border rounded-lg overflow-hidden">
              <img
                src={URL.createObjectURL(item.file)}
                alt={item.file.name}
                className="w-full h-32 object-cover"
              />
              <button
                type='button'
                
                onClick={() => handleRemoveFile(index)}
                className="absolute top-2 right-2 bg-red-500 text-white rounded-full p-1"
              >
                <FiTrash2 className="text-lg" />
              </button>
              <div className="absolute bottom-2 right-2 bg-white text-black rounded-full p-1">
                <FiZoomIn className="text-lg" />
              </div>
              <div className="relative mt-2">
                <select
                  className="block w-full text-center text-sm text-gray-700 appearance-none bg-white  rounded-lg py-2 pl-3 pr-8 "
                  value={item.category}
                  onChange={(e) => handleCategoryChange(index, e.target.value)}
                >
                  <option value="Balcony">Balcony</option>
                  <option value="Kitchen">Kitchen</option>
                  <option value="Floor Plan">Floor Plan</option>
                  <option value="Hall">Hall</option>
                  <option value="Bathroom">Bathroom</option>
                </select>
                <div className="absolute inset-y-0 right-3 flex items-center pointer-events-none">
                  <svg className="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7"></path>
                  </svg>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default UploadComponent;
